import { useEffect, useState } from "react";
import * as api from "../../api";
import Dialogo from "./Dialogo";
import ExploradorNotion from "./ExploradorNotion";
import FuenteNotion from "./FuenteNotion";
import ListasNotion from "./ListasNotion";

// «Mi lista de Notion» (T-141, T-144): si ya hay listas se ven primero (y se pueden quitar); despues se elige la base en
// el explorador y se revisan columnas y vista previa.
export default function ElegirListaNotion({ onCerrar, onConectar, onGuardada, onCambio, showToast }) {
  const [listas, setListas] = useState(null);       // null = leyendo
  const [paso, setPaso] = useState("listas");       // listas | explorar | mapeo
  const [base, setBase] = useState(null);

  useEffect(() => {
    api.fuentesNotion()
      .then(d => { const l = d.items || []; setListas(l); if (!l.length) setPaso("explorar"); })
      .catch(() => { setListas([]); setPaso("explorar"); });
  }, []);

  const titulo = paso === "listas" ? "Mis listas de Notion" : paso === "mapeo" ? "Mi lista de tareas de Notion" : "Elige tu lista de tareas de Notion";
  return (
    <Dialogo titulo={titulo} onCerrar={onCerrar} ancho={680}>
      {listas === null ? <p className="mt-sel-nota" role="status">Leyendo tus listas…</p>
        : paso === "listas" ? (
          <ListasNotion listas={listas} onOtra={() => setPaso("explorar")} onCerrar={onCerrar} showToast={showToast} onCambio={onCambio}
            onQuitada={id => { const l = listas.filter(x => x.id !== id); setListas(l); if (!l.length) setPaso("explorar"); }} />
        ) : paso === "mapeo" ? (
          <FuenteNotion base={base} onCambiarBase={() => setPaso("explorar")} onCancelar={onCerrar} onGuardada={onGuardada} />
        ) : <ExploradorNotion onElegir={b => { setBase(b); setPaso("mapeo"); }} onConectar={onConectar} />}
    </Dialogo>
  );
}
